"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageBreadcrumb = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _index = require("../Icon/index");
var _PageBreadcrumb = require("./PageBreadcrumb.styles");
var _excluded = ["backButton", "children"];
/**
 * The page breadcrumb is used for navigational elements preceding the page title.
 *
 * @extends PageContent
 * @since 8.15.0
 */
var PageBreadcrumb = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var backButton = _ref.backButton,
    children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var backButtonClone = backButton && /*#__PURE__*/(0, _react.cloneElement)(backButton, {
    icon: /*#__PURE__*/_react.default.createElement(_index.IconChevronLeft, null)
  });
  return /*#__PURE__*/_react.default.createElement(_PageBreadcrumb.StyledPageBreadcrumb, (0, _extends2.default)({
    ref: forwardedRef
  }, rest), backButtonClone, children);
});
exports.PageBreadcrumb = PageBreadcrumb;
PageBreadcrumb.displayName = 'PageBreadcrumb';
PageBreadcrumb.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A `TextButton` that will be augmented with a back icon.
   */
  backButton: _propTypes.default.node.isRequired,
  /**
   * Children content will be placed directly into the breadcrumb row.
   */
  children: _propTypes.default.node
} : {};